import React from 'react';

const Projects = () => {
  return (
    <div className="projects-page">
      <h1>Projects</h1>
      <p>Projects list will be here...</p>
    </div>
  );
};

export default Projects;